import type { AuthResponse, User } from '@conversia/shared-types';
import { api } from './client';

/** Endpoints de autenticación. Prefijo: /api/auth */

// A4 · NO hay helper de `register` acá, a propósito. `POST /api/auth/register`
// dejó de ser público (exige ADMIN) y ninguna pantalla del panel lo usaba: el
// helper que venía del repo de origen llevaba `skipAuth: true` y hoy solo
// produciría un 401 silencioso. El alta del equipo va por `/usuarios`
// (invitación) y se canjea con `acceptInvitation`, más abajo.

export const login = (input: { email: string; password: string }) =>
  api.post<AuthResponse>('/api/auth/login', input, { skipAuth: true });

export const refresh = (refreshToken: string) =>
  api.post<AuthResponse>('/api/auth/refresh', { refreshToken }, { skipAuth: true });

export const logout = (refreshToken: string) =>
  api.post<{ success: boolean }>('/api/auth/logout', { refreshToken }, { skipAuth: true });

export const me = () => api.get<User>('/api/auth/me');

/** Canjea una invitación: crea la cuenta del invitado con su contraseña. */
export const acceptInvitation = (input: { token: string; password: string; name?: string }) =>
  api.post<User>('/api/auth/accept-invitation', input, { skipAuth: true });

/** "Olvidé mi contraseña": respuesta idéntica exista o no la cuenta. */
export const forgotPassword = (email: string) =>
  api.post<{ message: string }>('/api/auth/forgot-password', { email }, { skipAuth: true });

/** Canjea el token de reset y fija la clave nueva. */
export const resetPassword = (input: { token: string; password: string }) =>
  api.post<{ success: boolean }>('/api/auth/reset-password', input, { skipAuth: true });

/** "Cambiar contraseña" del propio usuario: exige la actual; cierra las otras sesiones. */
export const changePassword = (input: { currentPassword: string; newPassword: string }) =>
  api.post<{ success: boolean }>('/api/auth/change-password', input);
